import { createContext, useContext, useState, type ReactNode } from "react";

type Direction = "left" | "right" | undefined;

const PanelTransitionContext = createContext<Direction>(undefined);

export function PanelTransition({
  viewKey,
  depth,
  children,
}: {
  viewKey: string;
  depth: number;
  children: ReactNode;
}) {
  const [transition, setTransition] = useState<{
    viewKey: string;
    depth: number;
    direction: Direction;
  }>({ viewKey, depth, direction: undefined });

  if (transition.viewKey !== viewKey || transition.depth !== depth) {
    setTransition({
      viewKey,
      depth,
      direction:
        transition.depth === depth
          ? undefined
          : depth > transition.depth
            ? "right"
            : "left",
    });
  }

  return (
    <PanelTransitionContext value={transition.direction}>
      {children}
    </PanelTransitionContext>
  );
}

export function usePanelTransition() {
  return useContext(PanelTransitionContext);
}
